export default __webpack_public_path__ + "static/media/86t.9e548efe.jpg";